const e = "2.3.0-beta.1";
export {
  e as version
};
//# sourceMappingURL=version.js.map
